import {
  DtoBase,
  SharedModels,
  TenantModels,
  UserModels,
} from '@project44-models/iam-gateway';

import { CommandHandler, QueryHandler } from '../../../shared/domain/UseCase';
import { TenantSpecificTenantAdminRolesEnum } from '../../../UnifiedRoles/domain/enums';
import { TUnifiedRoleCollectionDto } from '../../../UnifiedRoles/domain/interfaces';
import { UserUnifiedRolesTenantSpecificAggregate } from '../../../User/domain/aggregates/UserUnifiedRolesTenantSpecific.aggregate';
import {
  ISpecificUserQueryUseCase,
  IUserCreatorCommandUseCase,
  IUserFormCreator,
  IUserTenantAgnosticUnifiedRolesQuery,
  IUserTenantAgnosticUnifiedRolesUpdateCommand,
  IUserTenantSpecificTenantAdminPolicyUpdateCommand,
  IUserTenantSpecificUnifiedRolesQuery,
} from '../../../User/domain/interfaces';

abstract class UserUnifiedRolesTenantContextUpdateUserCase extends CommandHandler<{
  user: DtoBase<UserModels.UserViewModel>;
  tenant: DtoBase<TenantModels.TenantViewModel>;
  unifiedRoles: DtoBase<SharedModels.UnifiedRoleCollectionViewModel>;
}> {}

export abstract class UserTenantSpecificUnifiedRolesQueryUserCase
  extends QueryHandler<
    {
      user: DtoBase<UserModels.UserViewModel>;
      tenant: DtoBase<TenantModels.TenantViewModel>;
    },
    { userTenantSpecificUnifiedRoles: TUnifiedRoleCollectionDto }
  >
  implements IUserTenantSpecificUnifiedRolesQuery
{
  public readonly requiredAllOfPermissions = [];

  public readonly requiredAnyOfPermissions = [
    'system-admin:read:tenant-specific-user-role-assignments',
  ];
}

export abstract class UserTenantAgnosticUnifiedRolesQueryUserCase
  extends QueryHandler<
    {
      user: DtoBase<UserModels.UserViewModel>;
      tenant: DtoBase<TenantModels.TenantViewModel>;
    },
    { userTenantAgnosticUnifiedRoles: TUnifiedRoleCollectionDto }
  >
  implements IUserTenantAgnosticUnifiedRolesQuery
{
  public readonly requiredAllOfPermissions = [];

  public readonly requiredAnyOfPermissions = [
    'system-admin:read:tenant-agnostic-user-role-assignments',
  ];
}

export abstract class UserCreatorCommandUseCase
  extends CommandHandler<{
    userFormCreator: IUserFormCreator;
    tenant: DtoBase<TenantModels.TenantViewModel>;
  }>
  implements IUserCreatorCommandUseCase
{
  public readonly requiredAllOfPermissions = [];

  public readonly requiredAnyOfPermissions = ['system-admin:create:users'];
}

export abstract class SpecificUserQueryUseCase
  extends QueryHandler<
    {
      userId: string;
      tenant: DtoBase<TenantModels.TenantViewModel>;
      includeDeleted?: boolean;
    },
    { user: DtoBase<UserModels.UserViewModel> }
  >
  implements ISpecificUserQueryUseCase
{
  public readonly requiredAllOfPermissions = [];

  public readonly requiredAnyOfPermissions = ['system-admin:read:users'];
}

export abstract class UserTenantAgnosticUnifiedRolesUpdateUserCase
  extends UserUnifiedRolesTenantContextUpdateUserCase
  implements IUserTenantAgnosticUnifiedRolesUpdateCommand
{
  public readonly requiredAllOfPermissions = [];

  public readonly requiredAnyOfPermissions = [
    'system-admin:update:tenant-agnostic-user-role-assignments',
  ];
}

export abstract class UserTenantSpecificUnifiedRolesUpdateCommandUseCase
  extends UserUnifiedRolesTenantContextUpdateUserCase
  implements IUserTenantAgnosticUnifiedRolesUpdateCommand
{
  public readonly requiredAllOfPermissions = [];

  public readonly requiredAnyOfPermissions = [
    'system-admin:update:tenant-specific-user-role-assignments',
  ];
}
export abstract class UserTenantSpecificTenantAdminPolicyUpdateCommandUseCase
  extends CommandHandler<{
    userTenantSpecificRolesHandler: UserUnifiedRolesTenantSpecificAggregate;
    tenantSpecificTenantAdminPolicy: TenantSpecificTenantAdminRolesEnum;
  }>
  implements IUserTenantSpecificTenantAdminPolicyUpdateCommand
{
  public readonly requiredAllOfPermissions = [
    'system-admin:read:tenant-specific-user-role-assignments',
    'system-admin:update:tenant-specific-user-role-assignments',
  ];

  public readonly requiredAnyOfPermissions = [];
}
